module.exports = __webpack_public_path__ + "img/Congratulations.7f3e7af6.png";